import { SORT_TENANTS_2 } from '@snowit/constants';

export const sortTenants = (a: string, b: string): number => {
  if (!SORT_TENANTS_2.includes(a)) return 1;
  if (!SORT_TENANTS_2.includes(b)) return -1;

  return SORT_TENANTS_2.indexOf(a) - SORT_TENANTS_2.indexOf(b);
};
